module.exports = __webpack_public_path__ + "static/homepage-profile-ben-4b83bf4b37b8c98e69e361667f6449d0.png";